<template>
  <div class="fullwidth narex collections">
    <my-area-nav />
    <small-button large v-on:click="createNew">+</small-button>
    <div class="collection-view">
      <div class="flex-images">
        <collection-group-image v-for="folder in folders" :key="folder.foldername"
          :foldername="folder.foldername" :image="folder.image" v-on:click="goFolder(folder.foldername)"
          v-on:delete="deleteFolder" />
        <div v-for="n in extraImages" :key="'xtra' + n" class="imdiv"></div>
      </div>
    </div>
    <dialog-zoomer v-on:close="lbHide" v-model="viz">
      <div class="white-panel">
        <div class="close-box small grey" v-on:click="lbHide"></div>
        <p>Enter a name for your new collection</p>
        <div style="padding:20px 0">
          <input type="text" size="30" placeholder="Collection Name" v-model="newname" />
        </div>
        <div style="padding:20px 0">
          <small-button v-on:click="completeCreateCollection">Create</small-button>
        </div>
      </div>
    </dialog-zoomer>
  </div>
</template>

<script>
import MyAreaNav from './MyAreaNav.vue'
import CollectionGroupImage from './CollectionGroupImage.vue'
import likeUtil from '@/utils/likes.js'
import '@/css/my-area.css'
import DialogZoomer from '@/components/dialogs/DialogZoomer.vue'

const badTest = new RegExp('<|>|script', 'i')

export default {
  components: {
    MyAreaNav,
    CollectionGroupImage,
    DialogZoomer
  },
  data () {
    return {
      folders: [],
      extraImages: 0,
      showZoom: false,
      curpos: 0,
      selImage: null,
      loaded: false,
      viz: false,
      newname: ''
    }
  },
  created () {
    if(!this.$store.getters.signedIn) {
      this.$ixr.push('/')
    }
    else {
      this.loadData()
    }
  },
  mounted () {
    window.addEventListener('resize', this.setExtraImages)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setExtraImages)
  },
  methods: {
    completeCreateCollection () {
      if(this.newname.length < 2) {
        alert('Name must be at least 2 characters long.')
        return
      }
      if(this.newname.length > 80) {
        alert('Name must be fewer than 50 characters long')
        return
      }
      if(badTest.test(this.newname)) {
        alert('The name may not contain html or script')
        return
      }
      this.$store.commit('addProfileFolder', this.newname)
      let fd = { foldername: this.newname, image_ids: [], image: null }
      this.folders.push(fd)
      this.viz = false
      this.setExtraImages()
    },
    deleteFolder(folderName) {
      if(this.folders.length < 2) {
        alert('You can\'t delete the last collection')
        return
      }

      this.folders = this.folders.filter(el => (el.foldername !== folderName))
      this.$store.commit('removeProfileFolder', folderName)
      this.setExtraImages()
    },
    createNew () {
      this.newname = ''
      this.viz = true
    },
    lbHide () {
      this.viz = false
    },
    setExtraImages () {
      let rowWidth = this.$k.getBreakpoint().columns
      let extra = this.folders.length % rowWidth
      if(extra > 0) {
        this.extraImages = rowWidth - extra
      }
    },
    goFolder(folderName) {
      this.$store.commit('setProfileFolder', folderName)
      this.$ixr.push('/my-area/collections/view')
    },
    async loadData () {
      this.loaded = false
      let likes = []
      for(let each of this.$store.state.profile.folders)
      {
        let arr = likeUtil.stringToNumberArray(each.image_ids)
        if(arr.length > 0) {
          likes.push(arr[0])
        }
      }
      let image_ids = likes.filter((item, pos) => likes.indexOf(item) === pos)
      let res = await this.$apix.post('collections/images', { image_ids: image_ids })
      let images = res.data
      let fds = []
      for(let folder of this.$store.state.profile.folders) {
        let fd = { foldername: folder.name }
        let arr = likeUtil.stringToNumberArray(folder.image_ids)
        if(arr.length > 0) {
          let image = images.find(el => el.image_id === arr[0])
          fd.image = image
        }
        fds.push(fd)
        
      }
      this.folders = fds
      this.setExtraImages()
      this.currentPos = 0
      this.loaded = true
    }
  },
  watch: {
    '$store.state.token': function () {
      if(!this.$store.getters.signedIn) {
        this.$ixr.push('/')
      }
    },
    /*
    '$store.state.profileFolder': function () {
      this.loadData()
    }
    */
  }
}
</script>

<style scoped>
.white-panel{
  background-color:#fff;
  border-radius:6px;
  padding:45px;
}
</style>